import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import CreatePartyPage from './components/CreatePartyPage';
import FeedbackForm from './components/FeedbackForm';
import Lobby from './components/lobby/LobbyPage';
import PartyPage from './components/party/PartyPage';
import TOS from './components/TOS';
import Profile from './components/profile/Profile';
import LandingPage from './components/landing/LandingPage';
import { AdminRoute, LoggedInRoute } from './components/PrivateRoute';
import Logout from './components/Logout';
import { BuilderComponent, builder } from '@builder.io/react';
import Loading from './components/common/Loading';
import NotFound from './components/common/NotFound';
import Cockpit from './components/cockpit/Cockpit';
import Connect from './components/cockpit/Connect';
import Game from './components/game/Game';
import { APP_TITLE_BASE } from './components/party/AppConstants';
import PartyDetails from './components/admin/PartyDetails';
import PartyList from './components/partyList/PartyList';

const BuilderIOCatchAllPage = () => {
  const [pageJson, setPage] = useState();
  const location = useLocation();

  useEffect(() => {
    builder
      .get('page', { url: location.pathname })
      // The value will be `null` if no page was found
      .promise()
      .then(setPage);
  }, [location]);

  useEffect(() => {
    document.title = `${APP_TITLE_BASE}`;
  }, [location]);

  return pageJson === undefined ? (
    <Loading />
  ) : pageJson ? (
    <BuilderComponent model='page' content={pageJson} />
  ) : (
    <NotFound />
  );
};

const BuilderEditing = () => <BuilderComponent model='page' />;

const Routes = () => {
  return (
    <Router>
      <Switch>
        <LoggedInRoute path='/profile' component={Profile} />
        <Route path='/game' component={Game} />
        <AdminRoute path='/admin' component={PartyDetails} />
        <LoggedInRoute path='/party-list' component={PartyList} />
        <AdminRoute path='/cockpit' component={Cockpit} />
        <AdminRoute path='/connect' component={Connect} />
        <LoggedInRoute path='/create' exact={true} component={CreatePartyPage} />
        <LoggedInRoute path='/lobby' exact={true} component={Lobby} />
        <Route path='/tos' exact={true} component={TOS} />
        <Route path='/logout' exact={true} component={Logout} />
        <LoggedInRoute path='/feedback' exact={true} component={FeedbackForm} />
        <Route path='/' exact={true} component={LandingPage} />
        <LoggedInRoute path='/party/:partyKey' exact={true} component={PartyPage} />
        <LoggedInRoute path='/p/:partyKey' exact={true} component={PartyPage} />
        <Route path='/b/:builderKey' exact={true} component={BuilderIOCatchAllPage} />
        <Route path='/builder-edit' exact={true} component={BuilderEditing} />
        <LoggedInRoute path='/:partyKey' exact={true} component={PartyPage} />
      </Switch>
    </Router>
  );
};

export default Routes;
